import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';

export type FdkButtonVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary';

export type FdkButtonType =
  | 'button'
  | 'submit'
  | 'reset';

export type FdkButtonWidth =
  | 'auto'
  | 'full';

@Component({
  selector: 'fdk-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    '[class.fdk-button-host--full-width]': "width === 'full'",
  },
})
export class FdkButtonComponent {
  @Input() variant: FdkButtonVariant = 'primary';
  @Input() type: FdkButtonType = 'button';
  @Input() width: FdkButtonWidth = 'auto';
  @Input({ transform: booleanAttribute }) disabled = false;
}
